import React, { useState } from "react";
import styled from 'styled-components';

import useInterval from "hooks/useInterval";

import { Text } from "components/Text";

import { formatDate } from "helpers/date";


const Clock = ({ format = 'HH:mm:ss', tzOffset, ...rest }) => {
  const [now, setNow] = useState(new Date().getTime());

  useInterval(() => {
    setNow(new Date().getTime());
  }, 1000);

  return (
    <TimeText {...rest}>
      {formatDate(now, format, { tzOffset })}
    </TimeText>
  );
};


const TimeText = styled(Text)`
  color: #fff;
  font-weight: 600;
`;

export default Clock;